const _excluded = ["fragmentElement", "configuration"],
  _excluded2 = ["fragmentElement", "configuration"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const registryBrand = Symbol.for('neptune-ui-fragment-registry');
const registryKey = '__neptune_ui_fragment_registry__';
export let registry = window[registryKey];
const initRegistry = () => {
  registry = {
    queue: [],
    handlers: {},
    fragments: {},
    [registryBrand]: registryBrand,
    flushQueue: () => {
      const unhandled = [];
      let queued;
      while (queued = registry.queue.shift()) {
        const _queued$ = queued[1],
          {
            fragmentElement,
            configuration
          } = _queued$,
          rest = _objectWithoutProperties(_queued$, _excluded);
        if (queued[0] in registry.handlers) {
          registry.handlers[queued[0]](fragmentElement, configuration, rest);
          registry.fragments[queued[0]].set(fragmentElement, queued[1]);
        } else {
          unhandled.push(queued);
        }
      }
      registry.queue.push(...unhandled);
    },
    refresh(fragmentName) {
      if (fragmentName in registry.fragments) {
        for (const [fragmentElement, data] of registry.fragments[fragmentName]) {
          registry.handlers[fragmentName](fragmentElement, data.configuration, data);
        }
      }
    },
    push([fragmentName, data]) {
      const {
          fragmentElement,
          configuration
        } = data,
        rest = _objectWithoutProperties(data, _excluded2);
      if (fragmentName in registry.handlers) {
        registry.handlers[fragmentName](fragmentElement, configuration, rest);
        registry.fragments[fragmentName].set(fragmentElement, data);
      } else {
        registry.queue.push([fragmentName, data]);
      }
    }
  };
};
if (registryKey in window) {
  const originalRegistry = window[registryKey];
  if (!originalRegistry || originalRegistry[registryBrand] !== registryBrand) {
    initRegistry();
    if (Array.isArray(originalRegistry)) {
      registry.queue = originalRegistry;
    }
    window[registryKey] = registry;
  }
} else {
  initRegistry();
  window[registryKey] = registry;
}
export function registerFragment(fragmentName, initCallback) {
  const isRefresh = fragmentName in registry.handlers;
  registry.handlers[fragmentName] = initCallback;
  if (isRefresh) {
    registry.refresh(fragmentName);
  } else {
    registry.fragments[fragmentName] = new Map();
  }
  registry.flushQueue();
}